const jsonConfig = require(`./${process.env.REACT_APP_ENVIRONMENT}.json`);
export default jsonConfig;
